<div id="container-educators">
    <h2 class="educators-page-topic">Educators' Resources</h2>

    <pq-loading [loading]="loading" [error]="error" *ngIf="error"></pq-loading>

    <ul *ngIf="!loading && !error">
        <li *ngFor="let link of resourceLinks">
          <h3>
            <a (click)="pushEducatorsClickToGA(link.title)" [href]='link.titleUrl | pqPathUpdate' target="_blank" *ngIf="link.titleUrl && !link.download && link.type !== 'platformBrowse'">{{link.title}}</a>

            <a (click)="pushEducatorsClickToGA(link.title)" [href]='link.titleUrl | pqPathUpdate' target="_blank" *ngIf="link.titleUrl && !link.download && link.type === 'platformBrowse' && !showCAPTCHA">{{link.title}}</a>

            <a (click)="pushEducatorsClickToGA(link.title)" [href]='link.titleUrl | pqPathUpdate' download target="_blank" *ngIf="link.titleUrl && link.download">{{link.title}}</a>

            <button *ngIf="link.titleUrl && !link.download && link.type === 'platformBrowse' && showCAPTCHA" type="button" (click)="handleCAPTCHACheck(link.titleUrl)" class="btn btn-link">{{link.title}}</button>

            <span *ngIf="!link.titleUrl">{{link.title}}</span>
          </h3>

          <p class="ed-resources-text" [innerHTML]="link.text" *ngIf="link.text"></p>

          <ul *ngIf="link.list">
            <li *ngFor="let item of link.list">
              <span *ngIf="!item.url">{{item.text}}</span>

              <a *ngIf="item.url && item.download" [href]="item.url | pqPathUpdate" download target="_blank">{{item.text}}</a>

              <a *ngIf="item.url && !item.download" [href]="item.url | pqPathUpdate" target="_blank">{{item.text}}</a>

              <ul *ngIf="item.links" class="list-links">
                <li *ngFor="let link of item.links">
                  <a *ngIf="link.download" [href]="link.url | pqPathUpdate" download target="_blank">{{link.text}}</a>
                  <a *ngIf="!link.download" [href]="link.url | pqPathUpdate" target="_blank">{{link.text}}</a>
                </li>
              </ul>
            </li>
          </ul>
          <p class="note" *ngIf="link.note">{{link.note}}</p>
        </li>
        <li>
            <h3>
              <a *ngIf="!showCAPTCHA" (click)="pushEducatorsClickToGA(productName + ' on the ProQuest Platform')" [href]="getProductPlatformUrl()" target=_blank>{{productName}} on the ProQuest Platform</a>
              <button *ngIf="showCAPTCHA" type="button" (click)="handleCAPTCHACheck()" class="btn btn-link">{{productName}} on the ProQuest Platform</button>
            </h3>
            <p class="ed-resources-text">Explore {{productName}}'s documents on the ProQuest academic platform, or cross-search {{productName}} with your other ProQuest products.</p>
        </li>
    </ul>

</div>
